import { ChakraBox as Box, ChakraText as Text } from "@airhelp/react-ui-components";
import { AutocompleteForm } from "modules/common/components";

import { FunnelButton } from "./FunnelButton";

const NewWayOfClamingMobile = () => (
  <>
    <Box>
      <AutocompleteForm ctaVariant="primary" buttonText="Check Manually" />
    </Box>
    <Box bgColor="greyscale.300" borderRadius="lg" px={2} my={6} p={4} mb={10}>
      <Text size="lg" fontWeight="medium" mb={4}>
        Or use your boarding pass.
      </Text>
      <FunnelButton type="scanner" />
      <FunnelButton type="uploader" />
    </Box>
  </>
);

export default NewWayOfClamingMobile;
